import * as localForage from "localforage";

export default {
  data() {
    return {}
  },
  methods: {
    async mixins_get_task(key) {
      return await localForage.getItem(key) || {}
    },
    async mixins_set_task(key, obj) {
      await localForage.setItem(key, obj)
    },
    async mixins_delete_task(key) {
      await localForage.removeItem(key)
    }
  }
}